import { create } from "zustand";
import type { SearchConfig } from "@ti/ui-mobile";
import type { FilerDataType } from "@/pages/transfer/List/components/Filter";

export interface SearchParams {
  searchSaveConfig?: Record<string, unknown>;
  filterSaveConfig?: Record<string, unknown>;
  setSearchSaveConfig: (data: SearchConfig) => void;
  setFilterSaveConfig: (data: FilerDataType) => void;
}

const useSearchParamsStore = create<SearchParams>((set) => ({
  searchSaveConfig: void 0,
  filterSaveConfig: void 0,
  setSearchSaveConfig: (data) => {
    set({ searchSaveConfig: data });
  },
  setFilterSaveConfig: (data) => {
    set({ filterSaveConfig: data });
  },
}));

export default useSearchParamsStore;
